<template>
    <div>
        <b-modal
            :no-close-on-backdrop="true" 
            scrollable 
            centered 
            size="xl"  
            @hide="this.emitEventCancel"
            :id="ModalIdAuditNoteDocument" 
            :title="this.$t('AuditAuth.DocumentTilte')"  
            :ok-title="$t('Shared.Close')" 
            @ok="this.emitEventCancel" 
            style="padding:none!important" 
            ok-only
        >
            <b-row>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ this.$t('AuditList.Resume') }}</h6>
							</div>
                            <div class="flex-container">
                                <div class="row">
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.UserName') }}</small><br>
                                            <b>{{ this.userName }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.NotesId') }}</small><br>
                                            <b>{{ this.entityCode2 }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.HeaderId') }}</small><br>
                                            <b>{{ this.entityCode }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.Date') }}</small><br>
                                            <b>{{ this.date }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-if="!showHistory">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('AuditList.Address') }}</small><br>
                                            <b>{{ this.address }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="float-left col text-muted p-item">
                                            <small>{{ this.$t('Shared.PatientName') }}</small><br>
                                            <b>{{ this.patientName }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-if="!showHistory">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ title }}</h6>
                            </div>
                            <div class="flex-container" v-for="(item, index) in this.splitItems(this.value)" :key="`ENTITY-${index}`">
                                <div class="row" v-if="item.name === 'NotesHeaderTable' && item.values.length != 0">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <b>{{ $t('AuditList.Header') }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-4" v-for="(control, i) in item.values" :key="`header-${i}`">
                                        <component
                                            :is="'TIssAuditNoteHeader'"
                                            :key="`header-${i}`"
                                            v-bind:id="`header-${i}`"
                                            v-bind:control="control"
                                        >
                                        </component>
                                    </div>
                                </div>
                                <div class="row" v-if="item.name === 'AttachmentNoteTable'">
                                    <div class="col-md-12">
                                        <div class="float-left col text-muted p-item">
                                            <b>{{ $t('AuditList.Documents') }}</b>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-for="(document, idx) in item.values" :key="`DOC-${idx}`">
                                        <div class="fileGroup">
                                            <div class="row uploaded_files align-items-center">
                                                <ul>
                                                    <li class="added" v-if="document.status == 'NEW' || document.status == 'UPDATE'">
                                                        <b class="added" >
                                                            {{ document.documentFilename }}
                                                        </b>
                                                    </li>
                                                    <li class="deleted" v-if="(document.status == 'DELETE') || document.status == 'UPDATE'">
                                                        <b class="deleted" >
                                                            {{ document.oldDocumentFilename }}
                                                        </b>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <b-row v-else>
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card activeCard">
						<div class="card-body">
                            <div class="d-flex align-items-start justify-content-between">
                                <h6 class="card-title flex-grow lower-line text-truncate">{{ $t('AuditList.History') }}</h6>
							</div>
                            <div class="flex-container">
                                <Timeline :value="EntityHistory" align="alternate" class="customized-timeline">
                                    <template #marker="slotProps">
                                        <span >
                                            <i :class="slotProps.item.icon" :style="'color: '+ slotProps.item.color + '; font-size: 1.5rem;'"></i>
                                        </span>
                                    </template>
                                    <template #content="slotProps">
                                        <div class="card mt-4">
                                            <div class="card-header">
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('Shared.Date') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.sysDate }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('AuditList.UserName') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.userName }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $t('AuditList.Address') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.ipAddress }}</b>
                                                </div>
                                                <div class="float-left col text-muted">
                                                    <small>{{ $tc('Shared.ActionsTxt') }}:&nbsp;</small>
                                                    <b>{{ slotProps.item.actionTrans }}</b>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="float-left col text-muted mb-2" v-for="(item, idx) in splitItems(slotProps.item)" :key="`HITEM-${idx}`">
                                                    <template v-if="item.name === 'NotesHeaderTable' && item.values.length != 0">
                                                        <div class="float-left col text-muted p-item">
                                                            <b>{{ $t('AuditList.Header') }}</b>
                                                        </div>
                                                        <div v-for="(control, i) in item.values" :key="`header-${idx}-${i}`">
                                                            <component
                                                                :is="'TIssAuditNoteHeader'"
                                                                :key="`header-${i}`"
                                                                v-bind:id="`header-${i}`"
                                                                v-bind:control="control"
                                                            >
                                                            </component>
                                                        </div>
                                                    </template>
                                                    <template v-if="item.name === 'AttachmentNoteTable'">
                                                        <div class="float-left col text-muted p-item" >
                                                            <b>{{ $t('AuditList.Documents') }}</b>
                                                        </div>
                                                        <div v-for="(document, idex) in item.values" :key="`HDOC-${idx}-${idex}`">
                                                            <div class="fileGroup">
                                                                <div class="row uploaded_files align-items-center">
                                                                    <ul>
                                                                        <li class="added" v-if="(document.status == 'NEW') || (document.status == 'UPDATE')">
                                                                            <b class="added" >
                                                                                {{ document.documentFilename }}
                                                                            </b>
                                                                        </li>
                                                                        <li v-if="(document.status == 'DELETE') || (document.status == 'UPDATE') " class="deleted">
                                                                            <b class="deleted" >
                                                                                {{ document.oldDocumentFilename }}
                                                                            </b>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </Timeline>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>

            <template #modal-footer>
                <b-button
                    variant="primary"
                    @click="emitShowHistory"
                >
                    {{ showHistory ? $t('AuditList.HideHistory') :  $t('AuditList.ShowHistory') }}
                </b-button>
                <b-button
                    variant="primary"
                    @click="emitEventCancel"
                >
                    {{ $t('Shared.Close') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Utils from '@/common/utils'
import AuditUtils from '@/components/pages/audit/AuditUtils.js'
import { EventBus } from '@/event-bus.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import AuditService from '@/services/audit.service'
import TIssAuditNoteHeader from '@/components/pages/audit/AuditNoteHeader'

export default {
    name: 'AuditClinicalNoteDocumentDialog',
    mixins: [ShowMessage],

    props: {
        VisibleDialog:Boolean,
        value: Object
    },

    components: {
        TIssAuditNoteHeader
    },

    data() {
        return {
            ModalIdAuditNoteDocument: 'ModalIdAuditNoteDocument',
            showHistory: false,
            EntityHistory: [],
        };
    },

    watch: {
        VisibleDialog(newVal) {
            if (newVal) {
                this.$bvModal.show(this.ModalIdAuditNoteDocument);
            }
        }
    },

    computed: {
        title() {
            return this.value ? `${this.$t('AuditList.Info')}: ${this.value.actionTrans}` : '';
        },

        date() {
            return this.value ? this.value.sysDate : '';
        },

        address() {
            return this.value ? this.value.ipAddress : '';
        },

        patientName() {
            return this.value?.patientName ?? '';
        },

        entityCode() {
            return this.value?.entityKeyValue ?? '';
        },

        entityCode2() {
            return this.value?.entityKeyValue2 ?? '';
        },

        entity() {
            return this.value?.entityName ?? '';
        },

        userName() {
            return this.value?.userName ?? '';
        },
    },

    methods: {
        emitEventCancel() {
            this.$bvModal.hide(this.ModalIdAuditNoteDocument);
            this.showHistory = false;
            this.EntityHistory = [];
            this.$emit('close');
        },

        splitItems(item) {
            const data = [];
            if (item) {
                try {
                    const obj = JSON.parse(item.payload);
                    if (Array.isArray(obj)) {
                        obj.forEach(element => {
                            const value = this.parseItem(element, item.action)
                            if (value !== undefined) {
                                data.push(value);
                            }
                        })
                    } else {
                        const value = this.parseItem(obj);
                        if (value !== undefined) {
                            data.push(value);
                        }
                    }
                }
                catch {
                    //TODO
                }
            }

            const result =[];
            const documents = data.filter(x => x.name == 'AttachmentNoteTable').map(x => x.values).flat(Infinity);
            const header = data.filter(x => x.name == 'NotesHeaderTable' || x.name == 'NotesHeaderGNTable').map(x => x.values).flat(Infinity);
            if (header) {
                result.push({name: 'NotesHeaderTable', values: header});
            }
            if (documents) {
                result.push({name: 'AttachmentNoteTable', values: documents});
            }

            return result;
        },

        parseItem(item, action) {
            let data = undefined;
            Object.keys(item).forEach((propertyName) => {
                let values = [];
                const entity = item[propertyName];
                if (propertyName === 'NotesHeaderTable') {
                    values = AuditUtils.parseEntity(propertyName, entity, action, this.allProperties);
                    data = {name: propertyName, values: values};
                } else if (propertyName === 'AttachmentNoteTable') {
                    if (Array.isArray(entity)) {
                        entity.forEach((e) => {
                            values = values.concat(this.parseDocumentEntity(e));
                        });
                    } else {
                        values = this.parseDocumentEntity(entity);
                    }
                    
                    data = {name: propertyName, values: values};
                }             
            });

            return data;
        },

        parseDocumentEntity(entity) {
            let currentValue = [];
            let originalValue = [];
            
            Object.keys(entity).forEach((j) => {
                const value = entity[j];
                if (j == 'CurrentValue') {
                    Object.keys(value).forEach((k) => {
                        currentValue.push({name: k, value: value[k]});
                    })
                } else if (j == 'OriginalValue') {
                    Object.keys(value).forEach((k) => {
                        originalValue.push({name: k, value: value[k]});
                    })
                }
            });

            const documentType = currentValue.find(x => x.name == 'Docdocumenttype');
            const documentFilename = currentValue.find(x => x.name == 'Docfilename');
            const oldDocumentType = originalValue.find(x => x.name == 'Docdocumenttype');
            const oldDocumentFilename = originalValue.find(x => x.name == 'Docfilename');
            const status = documentFilename != undefined && oldDocumentFilename != undefined 
                                ? (documentFilename.value != oldDocumentFilename.value ? 'UPDATE': 'CURRENT') 
                                : (documentFilename != undefined ? 'NEW' : 'DELETE');

            return [
                    {
                        documentType: documentType?.value, 
                        documentFilename: documentFilename?.value, 
                        oldDocumentType: oldDocumentType?.value,
                        oldDocumentFilename: oldDocumentFilename?.value,
                        status: status
                    }
            ];
        },
        
        emitShowHistory() {
            this.showHistory = !this.showHistory;
            if (this.showHistory) {
                EventBus.$emit('ShowWeel', true); 
                AuditService.getHistory(this.value.recId)
                    .then((response) => {
                        if (response.data && response.data.length > 0) {
                            this.EntityHistory = response.data;
                            this.EntityHistory.forEach((element) => {  
                                let { sysDate  } = element 
                                if (sysDate) element.sysDate = `${Utils.formatterDateTimeToString(sysDate)}`;
                                element.actionTrans = AuditUtils.translateAction(element.action);
                                element.moduleTrans = AuditUtils.translateModule(element.module);   
                                element.icon = element.recId == this.value.recId ? "mdi mdi-checkbox-marked-circle" :
                                    (element.action == 'WAA_INSERT' ? 'mdi mdi-plus-circle' : (element.action == 'WAA_UPDATE' ? 'mdi mdi-checkbox-blank-circle' : 'mdi mdi-minus-circle'));

                                element.color = element.action == 'WAA_INSERT' ? 'green' : (element.action == 'WAA_UPDATE' ? 'black' : 'red');
                            });
                        }
                        EventBus.$emit('ShowWeel', false);
                    })
                    .catch((error) => {
                        EventBus.$emit('ShowWeel', false); 
                        this.showResponseErrorMessage(error);
                    })
            }
        },
    }
}
</script>

<style scoped>
.deleted {
    color: red;
}
.added {
    color: green;
}
</style>